import React from "react";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";

const AAAGSDetailsFilter = ({
  userInfoData,
  allFilters,
  setAllFilters,
  searchFilterApplied,
  onClickSearch,
  onClickReset,
}) => {
  return (
    <CommonFilterStructure
      from={"aaags-details"}
      decryptedText={userInfoData}
      setFilters={setAllFilters}
      filters={allFilters}
      searchFilterApplied={searchFilterApplied}
      onClickSearch={onClickSearch}
      onClickReset={onClickReset}
      onlySearch={true}
    />
  );
};

export default AAAGSDetailsFilter;
